import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/PhoneMockup.png'
import _imports_1 from '../../assets/imgs/deal.png'
import _imports_2 from '../../assets/imgs/world.png'
import _imports_3 from '../../assets/imgs/money.png'
import _imports_4 from '../../assets/imgs/money1.png'
import _imports_5 from '../../assets/imgs/digi.png'
import _imports_6 from '../../assets/imgs/swap.png'
import _imports_7 from '../../assets/imgs/time.png'


const _withScopeId = n => (_pushScopeId("data-v-dad03cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "top white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case" }, null, -1))
const _hoisted_4 = { class: "grid gray white flx max mm20" }
const _hoisted_5 = { class: "rows" }
const _hoisted_6 = {
  class: "h1 mt100",
  id: "font-size"
}
const _hoisted_7 = {
  class: "h3 black mt20",
  id: "font-size"
}
const _hoisted_8 = { class: "frl mt20" }
const _hoisted_9 = { class: "rows center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "rows center max" }
const _hoisted_13 = {
  class: "h2",
  id: "font-size"
}
const _hoisted_14 = {
  class: "mt20 h3 black",
  id: "font-size"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "columns max" }
const _hoisted_17 = { class: "hide track" }
const _hoisted_18 = { class: "img" }
const _hoisted_19 = { class: "leftext" }
const _hoisted_20 = {
  ref: "block01",
  class: "txtblock"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3",
  id: "font-size"
}, "Squad Deals", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h4 black mt20",
  id: "font-size"
}, " Daily discounted squad deals from merchants ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "show",
  src: _imports_1
}, null, -1))
const _hoisted_24 = { class: "txtblock" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3",
  id: "font-size"
}, "Connect Your World", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h4 black mt20",
  id: "font-size"
}, " Connect your friends and family. Give and get updates on the best deals from each other. ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "show",
  src: _imports_2
}, null, -1))
const _hoisted_28 = { class: "txtblock" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3",
  id: "font-size"
}, "Receive Money", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h4 black mt20",
  id: "font-size"
}, " Local or cross-border in seconds with low fees ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "show",
  src: _imports_3
}, null, -1))
const _hoisted_32 = { class: "txtblock" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3",
  id: "font-size"
}, "Save Money", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h4 black mt20",
  id: "font-size"
}, " Shop and save together with squad eGiftCards ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "show",
  src: _imports_4
}, null, -1))
const _hoisted_36 = { class: "txtblock" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3",
  id: "font-size"
}, "Multiple Digital Assets", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h4 black mt20",
  id: "font-size"
}, " Support for digital currencies, gaming tokens, rewards, gift cards, stocks and more. ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "show",
  src: _imports_5
}, null, -1))
const _hoisted_40 = { class: "txtblock" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3",
  id: "font-size"
}, "Swap Assets", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h4 black mt20",
  id: "font-size"
}, "Exchange any digital asset with others", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "show",
  src: _imports_6
}, null, -1))
const _hoisted_44 = { class: "txtblock" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3",
  id: "font-size"
}, "Earn All the Time", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h4 black mt20",
  id: "font-size"
}, " Earn 3-5% on contributions to our liquidity pool and every time you use Roxe Pay ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "show",
  src: _imports_7
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_r_icon = _resolveComponent("r-icon")!
  const _component_Tail = _resolveComponent("Tail")!
  const _directive_trans = _resolveDirective("trans")!
  const _directive_trnew = _resolveDirective("trnew")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { theme: "white" })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createTextVNode("For Consumers")
        ])), [
          [_directive_trans]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createTextVNode(" Find exclusive deals, get the highest cashback on eGiftCards, make payments and more. ")
        ])), [
          [_directive_trans]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_r_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotostore(true))),
            class: "mr20 cur",
            icon: "ios",
            height: 70,
            width: "50%"
          }),
          _createVNode(_component_r_icon, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotostore())),
            class: "cur",
            height: 70,
            width: "50%",
            icon: "google"
          })
        ])), [
          [_directive_trans, 300]
        ])
      ])), [
        [_directive_trnew, 20]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)), [
        [_directive_trnew, 500]
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
        _createTextVNode("Shop Together, Save Together")
      ])), [
        [_directive_trans]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
        _createTextVNode(" A blockchain powered social"),
        _hoisted_15,
        _createTextVNode(" commerce app for everyone ")
      ])), [
        [_directive_trans, 200]
      ])
    ])), [
      [_directive_trnew, 20]
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            style: _normalizeStyle({ paddingTop: `${_ctx.divt}px` }),
            class: "divt"
          }, [
            _createElementVNode("img", {
              style: _normalizeStyle({ opacity: _ctx.data.app[0] ? 1 : 0 }),
              src: _imports_1
            }, null, 4),
            _createElementVNode("img", {
              style: _normalizeStyle({ opacity: _ctx.data.app[1] ? 1 : 0 }),
              src: _imports_2
            }, null, 4),
            _createElementVNode("img", {
              style: _normalizeStyle({ opacity: _ctx.data.app[2] ? 1 : 0 }),
              src: _imports_3
            }, null, 4),
            _createElementVNode("img", {
              style: _normalizeStyle({ opacity: _ctx.data.app[3] ? 1 : 0 }),
              src: _imports_4
            }, null, 4),
            _createElementVNode("img", {
              style: _normalizeStyle({ opacity: _ctx.data.app[4] ? 1 : 0 }),
              src: _imports_5
            }, null, 4),
            _createElementVNode("img", {
              style: _normalizeStyle({ opacity: _ctx.data.app[5] ? 1 : 0 }),
              src: _imports_6
            }, null, 4),
            _createElementVNode("img", {
              style: _normalizeStyle({ opacity: _ctx.data.app[6] ? 1 : 0 }),
              src: _imports_7
            }, null, 4)
          ], 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", null, [
            _createVNode(_component_r_icon, {
              icon: "phone1",
              height: 68,
              width: 60
            })
          ]),
          _hoisted_21,
          _hoisted_22,
          _hoisted_23
        ], 512),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            _createVNode(_component_r_icon, {
              icon: "world",
              height: 68,
              width: 60
            })
          ]),
          _hoisted_25,
          _hoisted_26,
          _createVNode(_component_r_icon, {
            icon: "soon",
            width: 122,
            height: 55
          }),
          _hoisted_27
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", null, [
            _createVNode(_component_r_icon, {
              icon: "dollor1",
              height: 68,
              width: 60
            })
          ]),
          _hoisted_29,
          _hoisted_30,
          _createVNode(_component_r_icon, {
            icon: "soon",
            width: 122,
            height: 55
          }),
          _hoisted_31
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", null, [
            _createVNode(_component_r_icon, {
              icon: "mony",
              height: 68,
              width: 60
            })
          ]),
          _hoisted_33,
          _hoisted_34,
          _createVNode(_component_r_icon, {
            icon: "soon",
            width: 122,
            height: 55
          }),
          _hoisted_35
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", null, [
            _createVNode(_component_r_icon, {
              icon: "digital",
              height: 68,
              width: 60
            })
          ]),
          _hoisted_37,
          _hoisted_38,
          _createVNode(_component_r_icon, {
            icon: "soon",
            width: 122,
            height: 55
          }),
          _hoisted_39
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", null, [
            _createVNode(_component_r_icon, {
              icon: "arr",
              height: 68,
              width: 60
            })
          ]),
          _hoisted_41,
          _hoisted_42,
          _createVNode(_component_r_icon, {
            icon: "soon",
            width: 122,
            height: 55
          }),
          _hoisted_43
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", null, [
            _createVNode(_component_r_icon, {
              icon: "hand",
              height: 68,
              width: 60
            })
          ]),
          _hoisted_45,
          _hoisted_46,
          _createVNode(_component_r_icon, {
            icon: "soon",
            width: 122,
            height: 55
          }),
          _hoisted_47
        ])
      ])
    ]),
    _createVNode(_component_Tail)
  ]))
}